import { z } from "zod";

export const timerBlockSchema = z
  .object({
    hasTimer: z.boolean(),
    limit_unit: z.enum(["minute", "hour", "day", "week", "month", "year"], {
      error: (issue) =>
        issue.input === undefined
          ? "La unidad de tiempo es requerida"
          : "Unidad de tiempo seleccionada no válida",
    }),
    limit_amount: z
      .int("La cantidad de tiempo debe ser un número entero")
      .positive("La cantidad de tiempo debe ser un número positivo")
      .min(1, "La cantidad de tiempo debe ser al menos 1"),
    limit_preventions: z
      .int("El número de revisiones debe ser un número entero")
      .nonnegative("El número de revisiones no puede ser negativo")
      .optional(),
    global_preventions: z.boolean().optional(),
  })
  .refine(
    (data) =>
      data.global_preventions === true || data.limit_preventions !== undefined,
    {
      path: ["limit_preventions"],
      error: "El número de revisiones es requerido",
    },
  );

export type TimerBlockType = z.infer<typeof timerBlockSchema>;
